import {
  IslandIcon,
  TreeIcon,
  TreeEvergreenIcon,
  CampfireIcon,
  TentIcon,
  VirusIcon,
  ToothIcon,
  MicroscopeIcon,
  FlaskIcon,
  StethoscopeIcon,
  SyringeIcon,
  HandHeartIcon,
  HeartbeatIcon,
  BabyIcon,
  BabyCarriageIcon,
  ArmchairIcon,
  ChairIcon,
  OfficeChairIcon,
  HospitalIcon,
  MosqueIcon,
  SynagogueIcon,
  ChurchIcon,
  CrossIcon,
  BirdIcon,
  ToolboxIcon,
  SuitcaseRollingIcon,
  SuitcaseIcon,
  HandbagIcon,
  HouseIcon,
  BuildingsIcon,
  CityIcon,
  BuildingIcon,
  BuildingApartmentIcon,
  AirplaneIcon,
  AirplaneTakeoffIcon,
  AirplaneInFlightIcon,
  TruckIcon,
  BusIcon,
  VanIcon,
  CarIcon,
  TrafficSignalIcon,
  TrafficConeIcon,
  BooksIcon,
  MedalMilitaryIcon,
  MedalIcon,
  ProjectorScreenIcon,
  StudentIcon,
  GraduationCapIcon,
  BackpackIcon,
  ConfettiIcon,
  BalloonIcon,
  CakeIcon,
  HamburgerIcon,
  BowlSteamIcon,
  CoffeeIcon,
  CashRegisterIcon,
  CreditCardIcon,
  MoneyIcon,
  WalletIcon,
} from "@phosphor-icons/react";

export const normalizeIcon = (icon: string) => {
  try {
    return icon
      .replaceAll(/[_\s]+/g, "-")
      .replaceAll(/([a-z0-9])([A-Z])/g, "$1-$2")
      .replaceAll(/([A-Z])([A-Z][a-z])/g, "$1-$2")
      .replaceAll(/-+/g, "-")
      .replaceAll(/^-|-$/g, "")
      .toLowerCase();
  } catch {
    return null;
  }
};

export const ICON_MAP = {
  island: IslandIcon,
  tree: TreeIcon,
  "tree-evergreen": TreeEvergreenIcon,
  campfire: CampfireIcon,
  tent: TentIcon,
  virus: VirusIcon,
  tooth: ToothIcon,
  microscope: MicroscopeIcon,
  flask: FlaskIcon,
  stethoscope: StethoscopeIcon,
  syringe: SyringeIcon,
  "hand-heart": HandHeartIcon,
  heartbeat: HeartbeatIcon,
  baby: BabyIcon,
  "baby-carriage": BabyCarriageIcon,
  armchair: ArmchairIcon,
  chair: ChairIcon,
  "office-chair": OfficeChairIcon,
  hospital: HospitalIcon,
  mosque: MosqueIcon,
  synagogue: SynagogueIcon,
  church: ChurchIcon,
  cross: CrossIcon,
  bird: BirdIcon,
  toolbox: ToolboxIcon,
  "suitcase-rolling": SuitcaseRollingIcon,
  suitcase: SuitcaseIcon,
  handbag: HandbagIcon,
  house: HouseIcon,
  buildings: BuildingsIcon,
  city: CityIcon,
  building: BuildingIcon,
  "building-apartment": BuildingApartmentIcon,
  airplane: AirplaneIcon,
  "airplane-takeoff": AirplaneTakeoffIcon,
  "airplane-in-flight": AirplaneInFlightIcon,
  truck: TruckIcon,
  bus: BusIcon,
  van: VanIcon,
  car: CarIcon,
  "traffic-signal": TrafficSignalIcon,
  "traffic-cone": TrafficConeIcon,
  books: BooksIcon,
  "medal-military": MedalMilitaryIcon,
  medal: MedalIcon,
  "projector-screen": ProjectorScreenIcon,
  student: StudentIcon,
  "graduation-cap": GraduationCapIcon,
  backpack: BackpackIcon,
  confetti: ConfettiIcon,
  balloon: BalloonIcon,
  cake: CakeIcon,
  hamburger: HamburgerIcon,
  "bowl-steam": BowlSteamIcon,
  coffee: CoffeeIcon,
  "cash-register": CashRegisterIcon,
  "credit-card": CreditCardIcon,
  money: MoneyIcon,
  wallet: WalletIcon,
};

const mapLeaveIcon = (icon: string) => {
  if (!icon) return SuitcaseRollingIcon;
  const normalized = normalizeIcon(icon);
  return ICON_MAP[normalized];
};

export default mapLeaveIcon;
